import React from 'react';
import { KitchenInventoryStockProvider } from 'contexts/kitchen/inventory-stock.context';
import KitchenInventoryStockContent from './content';

const KitchenInventoryStockLayout = () => {
  return (
    <KitchenInventoryStockProvider>
      <KitchenInventoryStockContent />
    </KitchenInventoryStockProvider>
  );
};

export default KitchenInventoryStockLayout;
